export const SET_CURRENT_CONTENT = "SET_CURRENT_CONTENT";
export const SET_CURRENT_TOTAL_CONTENT = "SET_CURRENT_TOTAL_CONTENT";
export const IS_SUCCESS_GET_CONTENT = "IS_SUCCESS_GET_CONTENT";
export const IS_ERROR_GET_CONTENT = "IS_ERROR_GET_CONTENT";
export const RESET_CURRENT_CONTENT = "RESET_CURRENT_CONTENT";

export const SET_TODOS = "SET_TODOS";
export const SET_CURRENT_TODO_PARTICIPANT = "SET_CURRENT_TODO_PARTICIPANT";
export const SET_CURRENT_TODO_UPDATE = "SET_CURRENT_TODO_UPDATE";
export const IS_SUCCESS_SAVE_TODO_PARTICIPANT =
  "IS_SUCCESS_SAVE_TODO_PARTICIPANT";
export const IS_SUCCESS_DELETE_TODO_PARTICIPANT =
  "IS_SUCCESS_DELETE_TODO_PARTICIPANT";
export const IS_ERROR_DELETE_TODO_PARTICIPANT =
  "IS_ERROR_DELETE_TODO_PARTICIPANT";
export const IS_ERROR_SAVE_TODO_PARTICIPANT = "IS_ERROR_SAVE_TODO_PARTICIPANT";
export const SET_TODOS_STATUS = "SET_TODOS_STATUS";
export const RESET_TODOS = "RESET_TODOS";
export const SET_LATEST_FOCUS_AREA = "SET_LATEST_FOCUS_AREA";
